import { render } from "./lateral_tramitador.vue?vue&type=template&id=897da9be"
import script from "./lateral_tramitador.vue?vue&type=script&lang=js"
export * from "./lateral_tramitador.vue?vue&type=script&lang=js"

import "./lateral_tramitador.vue?vue&type=style&index=0&id=897da9be&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__